'use strict';

var base = module.superModule;

var formValidation = require('../components/formValidation');
var createErrorNotification = require('../components/errorNotification');
const { saveUrlInSessionStorage, recoverUrlInSessionStorage } = require('../../../../../../app_custom_masymas/cartridge/client/default/js/redirectUrl');

function loyalGuruParamsErrorTrigger(data,form) {
    Object.keys(data.fieldErrors).forEach(function (field) {
        var errorMessage = data.fieldErrors[field];
        if (errorMessage != ''){
            var fieldElement = form.find(`[id=registration-form-${field}]`);
            fieldElement.addClass('is-invalid');
            fieldElement.siblings('.invalid-feedback').text(errorMessage).show();
        }
    });
}

function registrationDialogTrigger(data) {
    var $dialogContainer = $('.registrationAlertEmailSent');
    $dialogContainer.empty().html(data.dialogHtml);

    if ($('#registrationAlertEmailDialog').length > 0) {
        $('#registrationAlertEmailDialog').modal('show');
    } else if ($('#loginAlertEmailDialog').length > 0) {
        $('#loginAlertEmailDialog').modal('show');
    }
}

/**
 * Create an alert to display the alert message
 * @param {Object} message - Message to display
 * @param {string} notificationType - type of notification to print correct alert color
 */
 function displayMessageDoubleOptin(notificationType, message) {    
    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="mt-5 pt-5 add-to-wishlist-messages "></div>');
    }
    $('.add-to-wishlist-messages')
        .append(`<div class="fade show add-to-wishlist-alert text-center ${notificationType}">${message}</div>`);

    setTimeout(() => {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
}

function register () {
    $('form.registration').submit(function (e) {
        var form = $(this);
        var doubleOptinAlertMessageError = $('form.registration>span').attr('data-double-optin-error');
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $('form.registration').trigger('login:register', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    $('form.registration').trigger('login:register:error', data);
                    formValidation(form, data);
                } else {
                    registrationDialogTrigger(data);
                }
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.errorMessage) {
                    displayMessageDoubleOptin('alert-danger', err.responseJSON.errorMessage);
                    loyalGuruParamsErrorTrigger(err.responseJSON,form);
                } else {
                    displayMessageDoubleOptin('alert-danger' , doubleOptinAlertMessageError);
                }
                form.spinner().stop();
            }
        });
        return false;
    });
}

function login () {
    $('form.login').submit(function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $('form.login').trigger('login:submit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                    $('form.login').trigger('login:error', data);
                } else {
                    $('form.login').trigger('login:success', data);
                    var storedUrl = recoverUrlInSessionStorage();

                    if (storedUrl && storedUrl.includes('Checkout-Begin')) {
                        location.href = storedUrl;
                        sessionStorage.setItem ('mymUrlPrevious', "");
                    } else {
                        location.href = data.redirectUrl;
                    }
                }
            },
            error: function (data) {
                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $('form.login').trigger('login:error', data);
                    form.spinner().stop();
                }
            }
        });
        return false;
    });
}

function resetPassword () {
    $('.reset-password-form').submit(function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $('.reset-password-form').trigger('login:register', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                } else {
                    $('.request-password-title').text(data.receivedMsgHeading);
                    $('.request-password-body').empty()
                        .append('<p>' + data.receivedMsgBody + '</p>');
                    if (!data.mobile) {
                        $('#submitEmailButton').text(data.buttonText)
                            .attr('data-dismiss', 'modal');
                    } else {
                        $('.send-email-btn').empty()
                            .html('<a href="'
                                + data.returnUrl
                                + '" class="btn btn-primary btn-block">'
                                + data.buttonText + '</a>'
                            );
                    }
                }
            },
            error: function () {
                form.spinner().stop();
            }
        });
        return false;
    });
}

function clearResetForm () {
    $('#login .modal').on('hidden.bs.modal', function () {
        $('#reset-password-email').val('');
        $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
    });
}

function test () {
    $('#login-tab').on('click', function () {
        $('#register-tab').removeClass('active').attr('aria-selected', 'false');
        $('#login-tab').addClass('active').attr('aria-selected', 'true');
        $('#register').removeClass('active');
        $('#login').addClass('active');
    });
    
    $('#register-tab').on('click', function () {
        $('#login-tab').removeClass('active').attr('aria-selected', 'false');
        $('#register-tab').addClass('active').attr('aria-selected', 'true');
        $('#login').removeClass('active');
        $('#register').addClass('active');
    });
}

function hideShowPassword () {
    $('body').on('click', '.hideShow', function () {
        var inputPassword = $('#registration-form-password');
        if(inputPassword.attr('type') === 'password') {
            inputPassword.attr('type','text');
            $('.icon').removeClass('fa fa-eye-slash').addClass('fa fa-eye');
        } else {
            inputPassword.attr('type','password');
            $('.icon').removeClass('fa fa-eye').addClass('fa fa-eye-slash');
        }
    });
    $('body').on('click', '.hideShowLogIn', function () {
        var inputPassword = $('#login-form-password');
        if(inputPassword.attr('type') === 'password') {
            inputPassword.attr('type','text');
            $('.icon').removeClass('fa fa-eye-slash').addClass('fa fa-eye');
        } else {
            inputPassword.attr('type','password');
            $('.icon').removeClass('fa fa-eye').addClass('fa fa-eye-slash');
        }
    });
}

function hideShowPasswordConfirm () {
    $('body').on('click', '.hideShowConfirm', function () {
        var inputPassword = $('#registration-form-password-confirm');
        if(inputPassword.attr('type') === 'password') {
            inputPassword.attr('type','text');
            $('.iconConfirm').removeClass('fa fa-eye-slash').addClass('fa fa-eye');
        } else {
            inputPassword.attr('type','password');
            $('.iconConfirm').removeClass('fa fa-eye').addClass('fa fa-eye-slash');
        }
    });
}
var exports = {
    register: register,
    login: login,
    resetPassword: resetPassword,
    clearResetForm: clearResetForm,
    hideShowPassword: hideShowPassword,
    hideShowPasswordConfirm: hideShowPasswordConfirm,
    test: test
}

module.exports = Object.assign({}, base, exports);